export enum AccessLevel {
  none = 'none',
  ro = 'ro', // Read Only
  rw = 'rw', // Read Write
}

export interface MenuItem {
  item: string;
  route?: string;
  icon?: string;
  iconPath?: string;
  permissionKey?: string;
  permission_key?: string;
  requiredGroup?: string;
  auth?: {
    view?: string;
    crud?: string;
  };
  children?: MenuItem[];
}

export interface ConfigField {
  defaultValue: string;
  fieldType: 'Color' | 'NumberStepper' | 'String' | 'Select' | 'Text' | 'File';
  userValue: string;
}

export interface ConfigNode {
  item?: string;
  icon?: string;
  iconPath?: string;
  children?: ConfigNode[];
  // Permettiamo chiavi dinamiche per supportare la struttura richiesta
  [key: string]: any;
}

export interface UserConfig {
  items: ConfigNode[];
}

export interface UserGroup {
  name: string;
  email: string;
  role: string;
  membersCount?: number;
}

export interface UserProfile {
  id: string;
  personaId?: number;
  email: string;
  full_name?: string;
  avatar_url?: string;
  hilight_color?: string;
  role: string;
  groups: UserGroup[];
  permissions: Record<string, AccessLevel>;
  authError?: string;
}

export interface AuthState {
  user: UserProfile | null;
  loading: boolean;
}
